eSocial.ComparadorDeAuditorias = (function()
{
    // URLSearchParams não funciona não Internet Explorer 11
    // A função abaixo tem o mesmo objetivo que ela estava fazendo
    // no código abaixo, mas funciona no IE11.
    var URLSearchParamsInternal = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null){
            return null;
        }
        else {
            return decodeURI(results[1]) || 0;
        }
    }
    var comparar = function(elementId)
    {
        var desenvolvedor = URLSearchParamsInternal('desenvolvedor');
        var handleOrigem = URLSearchParamsInternal('origem');
        var handleDestino = URLSearchParamsInternal('destino');
        $("#auditoriaOrigem").html(handleOrigem);
        $("#auditoriaDestino").html(handleDestino);
        var metodo = "BuscarXmlsUsuario";
        if(desenvolvedor == '1')
            metodo = "BuscarXmlsDesenvolvedor";
        AGA.Ajax.callWebMethodBlocked(metodo, {
            origem: handleOrigem,
            destino : handleDestino
        }, function(data){
            montarComparador(data.d["origem"], data.d["destino"], elementId);
        }, function(data, message){
            alert("Erro ao buscar as auditorias: " + message);
        });
    }
    var montarComparador = function(conteudoOrigem, conteudoDestino, elementId){
        conteudoOrigem = eSocial.FormatadorDeXml.formatXml3Th(conteudoOrigem);
        conteudoDestino = eSocial.FormatadorDeXml.formatXml3Th(conteudoDestino);
        import('ace-diff/dist/ace-diff.min').then(function (module)
        {
            
            let diff = module.default;
            new diff({
                element: elementId,
                left: {
                    editable: false,
                    copyLinkEnabled: false,
                    content: conteudoOrigem
                },
                right: {
                    editable: false,
                    copyLinkEnabled: false,
                    content: conteudoDestino
                }
            });
        });
    }
    var abrirComparador = function(origem, destino)
    {
        if(origem == undefined || destino == undefined)
            console.error("É necessário definir o handle de origem e o handle de destino.")
        Benner.ModalPage.show({
            url: $("#Wes2008ApplicationPath").val()+"aga/e/eSocial/comparadorAuditorias.aspx?desenvolvedor=1&imp=1&origem="+origem+"&destino="+destino,
            id: "modalComparadorAuditoriasESocial",
            size: "fullpage",
            height: 720,
            title: "Comparador de auditorias do eSocial"
        });
    }
    return {
        abrirComparador: function(origem, destino){
            abrirComparador(origem, destino);
        },
        comparar: function(elementId){
            comparar(elementId);
        },
    }
})();